import { IMetadataRuleData } from '@components/mapping-panel/components/RuleBuilder/MetadataRuleGroup/typed';
import { IRuleGroup } from '@components/mapping-panel/components/RuleBuilder/RuleGroup/typed';
import { EStringOp } from '@src/emp-3.0/types';

import { IActiveIndices } from '../store';
import { EMappingRuleType } from '../typed';

export const getEmptyRuleItem = () => ({
  tagKey: null,
  tagValue: {
    operator: EStringOp.EQ,
    value: null,
  },
});

export const getEmptyMetadataItem = (key?: string) => ({
  key: key || '',
  op: EStringOp.EQ,
  value: [],
});

export const getEmptyRuleGroup = (): IRuleGroup => ({
  eventName: null,
  rules: [[getEmptyRuleItem()]],
});

export const getEmptyMetadataGroup = (): IMetadataRuleData => ({
  metadata: [[getEmptyMetadataItem()]],
});

export const getInitialActiveIndices = (): IActiveIndices => ({
  ruleType: EMappingRuleType.NORMAL,
  orIndex: 0,
  eventName: false,
  ruleItems: [],
});
